import { SportModel } from "../..";
import { Sport } from "sb-resp-lib";

const sportOrderToHide = -4;

type eventsCount = {
    fixturesCount?: number;
    liveFixturesTotalCount?: number;
    liveOutrightsTotalCount?: number;
}

type sportData = {
    id?: string;
    order?: number;
    name?: string;
    fixturesCount?: number;
    liveFixturesTotalCount?: number;
}

export type cmsSportOrder = {
    sportId: string;
    activeInCms: boolean;
    order: number;
}

export type sportDataMapper = (sport:sportData) => SportModel
export type countMapper = (count: eventsCount) => number

export const sportMapperFactory = (countMapper: countMapper, orders: cmsSportOrder[] = []) : sportDataMapper => {
    return (sport:Sport) =>
        (new SportModel({
            id: sport.id || "",
            name: sport.name || "",
            order: cmsOrderMapper(sport, orders),
            numberOfEvents: countMapper(sport)
        }));
}

export const preLiveCountMapper: countMapper = (sport) => sport.fixturesCount || 0;

export const liveCountMapper: countMapper = (sport) => (sport.liveFixturesTotalCount || 0) + (sport.liveOutrightsTotalCount || 0);

export const todayCountMapper: countMapper = (sport) => sport.fixturesCount || 0;

const cmsOrderMapper = (sport: sportData, orders: cmsSportOrder[] = []) : number => {
    if (orders.length === 0)
    {
        return sport.order || 0;
    }
    const foundOrder = orders.find(o => `${o.sportId}` === sport.id);

    const result = foundOrder === undefined ? ((sport.order || 0) + 200) : foundOrder.activeInCms ? foundOrder.order : sportOrderToHide;

    return result;
}
